import { useAuthService } from '@/utils/useAuthService';
import NiceModal from '@ebay/nice-modal-react';

import Watermark from '@/components/watermark';
import { history, matchRoutes } from '@umijs/max';
import { ConfigProvider, message } from 'antd';
import React, { useEffect } from 'react';
import NoAccess from './pages/403';
import NoFind from './pages/404';

// @ts-ignore
import { ProConfigProvider } from '@ant-design/pro-components';
import dayjs from 'dayjs';
import { User } from 'oidc-client-ts';
import { AbbTextSvg } from './assets/icon';
import { HeaderTitleRender } from './layouts/headerTitleRender';
import { RightContentRender } from './layouts/rightContentRender';
import {
  getListAysnc,
  getRolePermissionsListAysnc,
} from './services/rebate-api/permissions';
import { getSystemUser } from './services/rebate-api/user';
import { useBaseConfigStore } from './store/config';
import { GlobalStyles } from './styles';
import { theme } from './styles/theme';
import { valueTypeMap } from './styles/valueType';
import requestConfig from './utils/requestConfig';
import { flattenTree } from './utils/treeUtils';
import { startVersionCheck } from './utils/versionCheck';
// 记录用户信息
let userInfo: any = { permissions: [] };

export const request = requestConfig;

export async function getInitialState(): Promise<any> {
  localStorage.setItem(
    'mrcs-userAuthorization',
    JSON.stringify(userInfo.permissions),
  );
  return {
    ...(userInfo || {}),
    isABB: userInfo?.userType === 'ABB',
    nameCn: userInfo?.name,
  };
}

// @ts-ignore
export const layout = ({ initialState, ...props }) => {
  const baseConfigStore = useBaseConfigStore();
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'monochrome-light');
    baseConfigStore.getConfigAsync();
  }, []);
  return {
    logo: AbbTextSvg,
    style: {
      height: '100vh',
    },
    pageTitleRender: (props: any) => PROJECT_NAME,

    menu: {
      locale: false,
      collapsedShowGroupTitle: true,
      autoClose: false,
    },
    collapsedButtonRender: false,
    token: {
      header: {
        // heightLayoutHeader: 48,
      },
      sider: {
        colorMenuBackground: 'white',
        colorTextMenuSelected: '#3366FF',
        colorBgMenuItemSelected: 'rgba(51, 102, 255, 0.08)',
        colorTextMenu: 'rgba(31, 31, 31, 1)',
      },
    },
    breakpoint: true,
    // 默认收齐彩蛋选择框
    // defaultCollapsed: true,
    fixedHeader: false,
    // fixSiderbar: true,
    // splitMenus: true,
    layout: 'top',
    // siderWidth: 208,
    // 自定义 403 页面
    unAccessible: <NoAccess />,
    // // 自定义 404 页面
    noFound: <NoFind />,
    headerTitleRender: (logo: any) => {
      return <HeaderTitleRender logo={logo} title={PROJECT_NAME} />;
    },
    rightContentRender: (props: any) => {
      return <RightContentRender {...props} initialState={initialState} />;
    },

    // menuFooterRender,
    // iconfontUrl: '//at.alicdn.com/t/c/font_4193534_9b9e1s67ey.js',
    // childrenRender: (children) => {
    //   return <Layout>
    //     <Content>
    //       {/* {
    //         location.pathname !== '/home/index' && <Breadcrumb flattenRoutes={flattenRoutes} initialState={initialState} />
    //       }
    //       <div style={{ padding: '0 16px', }}> */}
    //       {children}
    //       {/* </div> */}
    //     </Content>
    //     {/* <FooterRender /> */}
    //   </Layout>
    // }
  };
};

// @ts-ignore
export function onRouteChange({ clientRoutes, location }) {
  console.log(clientRoutes, 'clientRoutes');
  console.log(location, 'location');
  const route: any = matchRoutes(clientRoutes, location.pathname)?.pop()?.route;
  route ? (document.title = route.name || '') : history.push('/404');
  // window.scrollTo(0, 0);
  document.getElementById('scrollId')?.scrollTo(0, 0);
}

// 处理一下 登陆校验 和  获取用户信息
export const render = async (oldRender: () => void) => {
  const { getUser, login, logout, signinCallback, startTokenAutoRefresh } =
    useAuthService();
  if (window.location.pathname === '/login') {
    await login();
    oldRender();
    return true;
  }

  const userInfoData = await getUser();
  // 处理账号禁用 接口无权限一直loading问题
  if (window.location.pathname === '/403' && !userInfoData?.profile?.name) {
    oldRender();
    message.error('无权限访问');
    return true;
  } else if (window.location.pathname === '/403') {
    //处理接口403 把用户信息清空问题
    const res: any = await getUser();
    if (res?.isSuccess) {
      userInfo = res?.data || {};
    }
    oldRender();
    return true;
  }

  let auth: User | null = null;
  try {
    auth = await signinCallback();
  } catch (error) {
    auth = await getUser();
    userInfo = auth?.profile || {};
    if (!auth) {
      // 存储从邮件过来的链接地址
      localStorage.setItem(
        'mrcs-emailLink',
        JSON.stringify(window.location.href),
      );
      await login();
    }
  }

  if (auth) {
    try {      
      //获取用户信息
        const profileDto: API.GetSystemUserParams = {
        fullName: String(auth?.profile?.FullName ?? auth?.profile?.name ?? ''),
      };
      try {
        const systemUserInfo = await getSystemUser(profileDto);
        if (systemUserInfo) {
          // 检查用户是否激活
          if (!systemUserInfo.isActive) {
            //message.error('用户未激活，请联系系统管理员激活用户和授权功能');
            //await logout();
            //history.push('/403');

            localStorage.removeItem('mrcs-userInfo');
            localStorage.removeItem('mrcs-userAuthorization');
            history.push('/403');
            oldRender();
            return true;
          }
          let rolePermissions: any[] = [];
          if (
            systemUserInfo.roleList?.length &&
            systemUserInfo.roleList?.length > 0 &&
            systemUserInfo.roleList?.[0]?.name === 'admin'
          ) {
            rolePermissions = await getListAysnc();
          } else {
            if (
              systemUserInfo.roleList?.length &&
              systemUserInfo.roleList?.length > 0
            ) {
              rolePermissions = await getRolePermissionsListAysnc({
                roleName: systemUserInfo.roleList?.[0]?.name || '',
              });
            }
          }

          const flattenedPermissions = rolePermissions
            ? flattenTree(rolePermissions)
            : [];

          userInfo = {
            ...(auth?.profile || {}),
            permissions: flattenTree(rolePermissions),
          };
          // 存储用户信息和权限到 localStorage
          localStorage.setItem('mrcs-userInfo', JSON.stringify(systemUserInfo));
          localStorage.setItem(
            'mrcs-userAuthorization',
            JSON.stringify(flattenedPermissions || []),
          );
        }
      } catch (error) {
        console.error('获取系统用户信息失败:', error);
        message.error('获取系统用户信息失败');
        return;
      }
    } catch (e) {}
    // 从邮件过来的链接地址
    const url = localStorage.getItem('mrcs-emailLink')!;
    if (url) {
      history.push(JSON.parse(url));
      localStorage.removeItem('mrcs-emailLink');
    }
  }

  // 启动token自动刷新（仅在成功认证后）
  if (auth) {
    startTokenAutoRefresh();
  }

  oldRender();
  startVersionCheck();
};

// @ts-ignore
const WrapProvider = ({ children }) => (
  <NiceModal.Provider>
    <ProConfigProvider valueTypeMap={valueTypeMap}>
      <ConfigProvider button={{ autoInsertSpace: false }} theme={theme}>
        <GlobalStyles />
        {children}
      </ConfigProvider>
    </ProConfigProvider>
  </NiceModal.Provider>
);

const RootWatermark = ({ children }: { children: React.ReactNode }) => {
  const [text, setText] = React.useState('');

  React.useEffect(() => {
    try {
      const raw = localStorage.getItem('mrcs-userInfo');
      if (!raw) {
        return;
      }
      const info = JSON.parse(raw);
      const name = info?.name || info?.userName || info?.email;
      const text = ` ${name},${dayjs().format('YYYY-MM-DD HH:mm')}`;
      setText(String(text || ''));
    } catch (e) {
      setText('');
    }
  }, []);

  return (
    <Watermark
      text={text}
      showWatermark={true}
      opacity={0.012}
      fontSize={24}
      fontColor={'#f00'}
    >
      {children}
    </Watermark>
  );
};

export function rootContainer(
  container:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | Iterable<React.ReactNode>
    | React.ReactPortal
    | null
    | undefined,
) {
  return React.createElement(
    WrapProvider,
    null,
    React.createElement(RootWatermark, null, container),
  );
}
